import React, {useState} from 'react';
import DatePicker from "react-datepicker";
import PropTypes from "prop-types";

const MonthYearPickerInput = ({label, className, isRequired, id}) => {
  const [startDate, setStartDate] = useState(new Date());

  return (
    <div className={`form-item month-year-picker ${className}`}>
      <DatePicker
        id={id}
        selected={startDate}
        onChange={date => setStartDate(date)}
        dateFormat="MMMM"
        showMonthYearPicker
        required={isRequired}
        className="date-picker"
      />
      {label && <label htmlFor={id}
        className={isRequired && 'required'}>{label}</label>}
    </div>
  );
};

MonthYearPickerInput.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  isRequired: PropTypes.bool,
  id: PropTypes.string,
}

MonthYearPickerInput.defaulProps = {
  isRequired: false,
  id: '',
}


export default MonthYearPickerInput;
